import apiClient, { handleApiError } from "../openApiClient";
import { UserSSOConfigResponse, ExtendedUserWithSessionResponse } from "@telegraphio/bapi-types";

export interface UserSSOApi {
  getConfig(): Promise<UserSSOConfigResponse | undefined>;
  getUser(token: string): Promise<ExtendedUserWithSessionResponse | undefined>;
}

export const userSSOApi: UserSSOApi = {
  async getConfig() {
    const { data, error, response } = await apiClient.GET("/user/login/sso");

    if (error) {
      if (response.status !== 404) {
        handleApiError(error, response, "Failed to load SSO config.");
      }
      // Unsure what to do with 404, it just means this isn't an external SSO customer, so it's not bad that we got a 404;
      return undefined;
    }

    return data;
  },
  async getUser(token: string) {
    const { data, error, response } = await apiClient.POST("/auth/callback", {
      body: {
        idToken: token,
      },
    });

    if (error) {
      handleApiError(error, response, "Failed to load SSO user.");
    }

    if (data) {
      return data;
    }
  },
};
